import { useMemo } from 'react';
import { VideoPlayer, type PlayerSource } from '@mlm/ui';
import { controlSrc, detectPlaybackProvider } from '@mlm/shared';

/**
 * A program day's video on the shared player: the same lazy chunk the course
 * player pays for, loaded only by a member who opens a day that has one. No
 * progress is written for it (a program day is marked done by hand).
 */
export function ProgramVideo({ src, title }: { src: string; title: string }) {
  const source: PlayerSource = useMemo(() => {
    const provider = detectPlaybackProvider(src);
    if (provider === 'file') return { kind: 'video', src, captions: [] };
    return {
      kind: 'iframe',
      // playsinline matters in the Android WebView: without it a tap goes
      // fullscreen in the system player.
      src: controlSrc(src, provider, { origin: window.location.origin, playsinline: true }),
      provider,
    };
  }, [src]);
  return (
    <div className="border-b border-border">
      <VideoPlayer
        source={source}
        title={title}
        protocolId={src}
        chrome={source.kind === 'video' ? 'native' : 'embed-strip'}
        preferences={{ rate: 1, captionsLang: null }}
      />
    </div>
  );
}
